import { useStore } from 'react-redux';
import { useState, useEffect } from 'react';
import { distance } from './Geometry.js';
import G from './Getters';
import CropWrapper from './CropWrapper';
import { ANNOTATION_IMAGE_ID } from './UIConstants';
import { useRef, useContext } from 'react';
import { FocusedAnnotationContext } from './Contexts';
import useElementDims from './useElementDims';

function ListOnlyDisplay({

}){
}

function ListWithPreview({

}){
}

let previewListStyle = {
  display:'flex',
  flexWrap:'wrap', 
}

let previewItemStyle = {
  //width:'45%',
  margin:'1.5%',
  borderRadius:3,
  padding:5,
  border:'1px solid #eee',
  display:'flex',
  flexDirection:'column',
  //background:'#ccc',
  //justifyContent:'center'
}

const listItemStyle = {
}


export default function CropListDisplay({
  atns=[],
  temporaryAnnotationProperties={},
  imageId,
  cropListMode,
  extraItems=[],
  onItemSelect,

}){
  const wrapperRef = useRef();
  const dims = useElementDims(wrapperRef);

  let { focusedAnnotationId, setFocusedAnnotationId } = useContext(FocusedAnnotationContext);


  let previewRef = useRef();
  const store = useStore();
  const state = store.getState();

  const listDisplay = cropListMode === "list";

  const listStyle = listDisplay ? {} : previewListStyle;
  const itemStyle = listDisplay ? listItemStyle : previewItemStyle;


  let atnWithDefinedLs = atns.filter(atn => atn.ls!==undefined);
  let unlabledRegionCount = 0;
  const listToDisplay = atnWithDefinedLs.map( (atn,ii) => {
    let atnOverride = focusedAnnotationId === atn._id ? temporaryAnnotationProperties : {};


    let inlineCrop = !listDisplay && (
      G.getCropFromAnnotation(state,atn._id, atnOverride)
    );

    let isFocusedAnnotation = focusedAnnotationId === atn._id;
    let className = isFocusedAnnotation ? 'selected' : undefined;

    let label;
    if( isFocusedAnnotation ){
      if( typeof(temporaryAnnotationProperties.label) !== 'string' ){
        label = atn.label;        
      }else{
        label = temporaryAnnotationProperties.label
      }
    }else{
      label=atn.label;
    }
    return { 
      label:label || "Crop " + (++unlabledRegionCount),
      _id:atn._id,
      inlineCrop,
      className,
    }
  });

  listToDisplay.splice(0,0,...(extraItems||[]));


  let focusedAtn = atns.find(atn => atn._id === focusedAnnotationId);


  return <>

    {false && focusedAtn && focusedAtn.ls && (<div>

      <div><h4>Dimensions</h4></div>
      <div>Width: <input value={distance(focusedAtn.ls)}/></div>
      <div>Height: <input value={focusedAtn.height}/></div>
    </div>)}

    <div style={{ height:20 }}/>

    <div ref={wrapperRef} style={{width:'100%', 
    ...listStyle
  }}>
    {listToDisplay.map(({label,_id,inlineCrop,className},ii) => {
      let betterStyle = {};
      if (dims != null) {
        betterStyle.height = inlineCrop.height * dims.width;
        betterStyle.width = inlineCrop.width * dims.width;
      }

      return (
        <div 

          onClick={e => {
            e.stopPropagation();
            if(onItemSelect){ onItemSelect(_id) }
            else{ setFocusedAnnotationId(_id) }

          }}
          class={(_id === focusedAnnotationId?"selected":"")} style={itemStyle}>
          <div class={"sg-row " + (listDisplay?"hoverable clickable":"")}>
            <div annotationIndex={""+ii} info={"annotationLabel"} 
              style={{fontSize:18}}>
              {label||`Unlabeled region (area = ${JSON.stringify(inlineCrop)})`}
            </div>
            <div class="flex-expand"/>
          </div>
          {!listDisplay && (<div style={dims != null ? betterStyle : { flex: 1 }}>
            <CropWrapper 
              forceSingleChannel={true}
              htmlImageId={ANNOTATION_IMAGE_ID}
              imgRef={previewRef} 
              imageId={imageId}
              inlineCrop={inlineCrop}/>
          </div>)}
        </div>
      )
    })}
  </div>

    

  </>
}
